import React from "react";
import logo from "../../../../assets/images/logo.png";
import { DesktopMainMenu, Imagedata, MenuLink, CTAWrapper } from "../styles";
import styled from "@emotion/styled";
import { Container } from "@mui/material";

const DesktopWrapper = styled.div`
  margin-top: 30px;
  animation: lockerDrop 0.8s cubic-bezier(0.18, 0.9, 0.22, 1.12) both;

  @keyframes lockerDrop {
    0% {
      opacity: 0;
      transform: translateY(-72px) scale(0.96);
      filter: blur(8px);
    }

    72% {
      opacity: 1;
      transform: translateY(6px) scale(1.01);
      filter: blur(0);
    }

    100% {
      opacity: 1;
      transform: translateY(0) scale(1);
      filter: blur(0);
    }
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }

  @media (max-width: 1200px) {
    display: none;
  }
`;

const Div = styled.div`
  display: flex;
  align-items: center;
  justify-content: right;
  flex: 1;
`;

const RightDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-left: 6px;

  &::before {
    content: "";
    width: 1px;
    height: 44px;
    margin-right: 6px;
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.83) 50%,
      rgba(255, 255, 255, 0) 100%
    );
  }
`;

const DesktopMenu = (props) => {
  const buttonItem = props.menuList.find(
    (item) => typeof item.title !== "string"
  );

  const menuItems = props.menuList.filter(
    (item) => typeof item.title === "string"
  );

  return (
    <DesktopWrapper>
      <Container maxWidth="md">
        <DesktopMainMenu>
          {/* Left - Logo */}
          <MenuLink href="/" p="0px">
            <Imagedata src={logo} alt="Logo" mw="48px" />
          </MenuLink>

          {/* Center - Menu Links */}
          <Div>
            {menuItems.map((value, i) => (
              <MenuLink
                p={value.p}
                Zidex={value.idex}
                key={i}
                href={value.link}
                target={value.target}
                className={value.customClass}
              >
                {value.title}
              </MenuLink>
            ))}
          </Div>

          {/* Right - CTA */}
          {buttonItem && (
            <RightDiv>
              <CTAWrapper>{buttonItem.title}</CTAWrapper>
            </RightDiv>
          )}
        </DesktopMainMenu>
      </Container>
    </DesktopWrapper>
  );
};

export default DesktopMenu;
